import { css } from 'styled-system/css';

type Props = { plus: boolean };

const barClass = css({ w: '14px', h: '2px', bg: 'gray.700', position: 'relative' });
const crossBarClass = css({
  w: '14px',
  h: '2px',
  bg: 'gray.700',
  position: 'absolute',
  transform: 'rotate(0deg)',
  transition: 'transform .3s',
  '&[data-plus]': { transform: 'rotate(90deg)' },
});

// atoms/Icons/plus without Chakra (the unused `chakraProps` override is dropped).
export const PlusMinusIconAnimated = ({ plus }: Props) => (
  <div className={barClass}>
    <div className={crossBarClass} data-plus={plus ? '' : undefined} />
  </div>
);
